import { QueryClientHelper } from '#pplx/frontend/react-query/QueryClientHelper.js';
export const ALL_ARTIFACTS_SEARCH_ENDPOINT = '/rest/assets/search';
export const SPACE_PINNED_ARTIFACTS_ENDPOINT = '/rest/spaces/{space_uuid}/pins/files';
export const getAllArtifactsSearchQueryKey = (assetType, query) => QueryClientHelper.makeQueryKey(ALL_ARTIFACTS_SEARCH_ENDPOINT, assetType, query);
export const getPinnedFilesQueryKey = (query) => query
    ? QueryClientHelper.makeQueryKey('/rest/assets/pins', query)
    : QueryClientHelper.makeQueryKey('/rest/assets/pins');
export const getSpacePinnedArtifactsQueryKey = (spaceUuid) => QueryClientHelper.makeQueryKey(SPACE_PINNED_ARTIFACTS_ENDPOINT, spaceUuid);
export const getSharedWithMeQueryKey = (query) => query
    ? QueryClientHelper.makeQueryKey('/rest/assets/shared-with-me', query)
    : QueryClientHelper.makeQueryKey('/rest/assets/shared-with-me');
export const getAssetRequestAccessInfoQueryKey = (assetId) => QueryClientHelper.makeQueryKey('/rest/assets/{asset_id}/request-access-info', assetId);
//# sourceMappingURL=assetsKeys.js.map